import { type NodeViewComponentProps } from "@handlewithcare/react-prosemirror";
import dynamic from "next/dynamic";
import { forwardRef } from "react";

const CodeBlock = dynamic(() => import("./CodeBlock").then((mod) => mod.CodeBlock), { ssr: false });

/**
 * Dynamically loads the CodeBlock component to avoid eagerly loading all the language extensions
 * and xterm which are fairly heavyweight.
 */
export const CodeBlockWrapper = forwardRef<HTMLDivElement | null, NodeViewComponentProps>(
	function CodeBlockWrapper(props, ref) {
		return (
			<div ref={ref} data-text-cell={props.nodeProps.node.attrs["id"]}>
				<CodeBlock {...props} />
			</div>
		);
	}
);
